/**
 * @generated SignedSource<<03227da03c566c997e9fd3c36d06265d>>
 * @relayHash 00244b823b9dd447b21dcc98390f9f59
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/491.0.0-2024-12-12T14:50:00.058Z/PdpSharedAddToCartButtonMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartType = "CHECKOUT" | "SAVE_FOR_LATER" | "%future added value";
export type UserCartItemAddOrUpdateInput = {
  clientMutationId?: string | null;
  itemId: string;
  quantity: number;
  skuId: string;
  type: CartType;
};
export type PdpSharedAddToCartButtonMutation$variables = {
  input: UserCartItemAddOrUpdateInput;
};
export type PdpSharedAddToCartButtonMutation$data = {
  readonly userCartItemAddOrUpdate: {
    readonly clientMutationId: string | null;
  } | null;
};
export type PdpSharedAddToCartButtonMutation = {
  response: PdpSharedAddToCartButtonMutation$data;
  variables: PdpSharedAddToCartButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserCartItemAddOrUpdatePayload",
    "kind": "LinkedField",
    "name": "userCartItemAddOrUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedAddToCartButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PdpSharedAddToCartButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/491.0.0-2024-12-12T14:50:00.058Z/PdpSharedAddToCartButtonMutation",
    "metadata": {},
    "name": "PdpSharedAddToCartButtonMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c6f3227badd3e2f8eb1de79dfdfd31d9";

export default node;
